import JSONCrush from "jsoncrush";

const makeLineItem = (
  productId,
  variantId,
  productTitle,
  variantTitle,
  productType,
  productPoints,
  points,
  price,
  quantity,
  image,
  otherProps
) => {
  return {
    productId,
    variantId,
    productTitle,
    variantTitle,
    productType,
    productPoints,
    points,
    price,
    quantity,
    image,
    ...otherProps,
  };
};

export const getCustomizationLineItem = (
  product,
  variant,
  canvasPatches,
  patchPoints = [],
  characterName = ""
) => {
  const callbackUrl = process.env.REACT_APP_CALLBACK_URL;
  const productId = product.id.replace("gid://shopify/Product/", "");
  const variantId = variant.id.replace("gid://shopify/ProductVariant/", "");
  const canvas = canvasPatches.map((e) => ({
    id: e.id,
    cen: e.center,
    coo: e.coordinates,
    pos: e.position,
    rot: e.rotation,
    top: e.top,
    lef: e.left,
    height: e.height,
    width: e.width,
  }));

  const encodedCanvas = encodeURIComponent(JSONCrush.crush(JSON.stringify(canvas)));
  const encodedPatchPoints = encodeURIComponent(JSONCrush.crush(JSON.stringify(patchPoints)));
  const stringifyValue = `https://${callbackUrl}/${productId}/${variantId}?data=${encodedCanvas}&points=${encodedPatchPoints}${
    characterName ? `&characterName=${encodeURIComponent(characterName)}` : ""
  }`;

  const otherProps = {
    customAttributes: {
      key: "_previewURL",
      value: stringifyValue,
    },
    currentCustomization: true,
  };
  return makeLineItem(
    product.id,
    variant.id,
    product.title,
    variant.title,
    product.productType,
    product.pointsIncluded,
    0,
    variant.price,
    1,
    variant.featuredImage,
    otherProps
  );
};

export const getPatchLineItems = (patches) => {
  const uniqueIds = [...new Set(patches.map((e) => e.id))];
  return uniqueIds.map((id) => {
    const patch = patches.find((e) => e.id === id);
    const quantity = patches.filter((e) => e.id === patch.id).length;
    return makeLineItem(
      patch.id,
      patch.vid,
      patch.title,
      "",
      "Patch",
      0,
      patch.points,
      0,
      quantity,
      patch.src
    );
  });
};

export const getPatchPointsPackLineItems = (packs) => {
  const uniqueIds = [...new Set(packs.map((e) => e.id))];
  return uniqueIds.map((id) => {
    const pack = packs.find((e) => e.id === id);
    const quantity = packs.filter((e) => e.id === pack.id).length;
    return makeLineItem(
      "",
      pack.id,
      `${pack.points} Patch Points`,
      "",
      "PatchPoints",
      pack.points,
      0,
      pack.price,
      quantity,
      pack.src
    );
  });
};

export const getMiscLineItems = (variants) => {
  return variants.map((variant) => {
    return makeLineItem(
      variant.product.id,
      variant.id,
      variant.product.title,
      variant.title,
      variant.product.productType,
      0,
      0,
      variant.price,
      variant.quantity,
      variant.image
    );
  });
};

export const getLineItemsWithMergedQuantity = (items) => {
  return items.reduce((array, item) => {
    if (item.productType === "Patch" && array.some((e) => e.variantId === item.variantId)) {
      const findIndex = array.findIndex((e) => e.variantId === item.variantId);
      return array.map((e, i) =>
        i === findIndex ? { ...e, quantity: e.quantity + item.quantity } : e
      );
    }
    return array.concat(item);
  }, []);
};
